import './Footer.css';

export default function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <p>&copy; 2026 Tufts CEEO.</p>
                <div className="footer-links">
                    <a href="#" className="footer-link">Disclaimer</a>
                </div>
            </div>
        </footer>
    );
}
